<!--
고객문의 > 문의상태 변경 컴포넌트
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical">

            <div class="uk-modal-header">
                <h4>문의상태 변경</h4>
            </div>

            <div class="uk-modal-body uk-padding-small">

                <app-input-ex
                    class="uk-margin"
                    type="radio"
                    name="state"
                    v-model="state"
                    label=""
                    init-error-msg=""
                    :options="stateOptions"
                ></app-input-ex>
            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },


        },
        data: function () {
            return {
                /**
                 * (object) 고객문의 오브젝트
                 **/
                qna: null,

                /**
                 * (string) 상태
                 */
                state: null,

                /**
                 * (array) 변경가능한 select box 옵션
                 */
                stateOptions: [
                    {text: '진행중', val: 1},
                    {text: '답변완료', val: 2},
                    {text: '보류중', val: 5},
                ],
            };
        },
        computed: {

        },
        methods: {
            /**
             * 입력폼 display
             */
            show() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param qna_id 고객문의ID
             */
            form(qna_id) {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/qnas/' + qna_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.qna = response.qna;
                    this.state = this.qna.state.toString();


                    // 폼띄우기
                    this.show();
                });
            },

            /**
             * submit
             */
            submit() {

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/qnas/' + this.qna.id + '/state',
                    data: {
                        '_token': this.csrfToken,
                        'state': this.state,
                    },
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>